module.exports = __webpack_public_path__ + "img/team-member-01.59e145d9.png";